import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';
import {
  rewordDictionary,
  statusTranslation,
  statusTranslationClass,
  statusTranslationLabels,
  statusTranslationSubtitles
} from './../config/config/config.constants';
import {newDate} from './../utils/date';
import {OrderDetailsService} from './../services/order-details/order-details.service';
import {MonthDayOnlyPipe} from './month-day-only.pipe';
import {Order} from './../contracts/order';

@Pipe({
  name: 'statusTranslation'
})
export class StatusTranslationPipe implements PipeTransform {

  constructor(private date: DatePipe,
    private monthDayOnly: MonthDayOnlyPipe,
    private _order: OrderDetailsService) {
  }

  transform(o: Order,
    args?: any,
    reword?: boolean,
    extraStr = ''): any {
    const oStatus = o.orderStatus;
    let translated = '';
    /**
     * Output a css class
     */
    if (args === 'class') {
      return statusTranslationClass[oStatus] || '';
    }
    /**
     * Output Order details page Header
     */
    if (args === 'odHeader') {
      return this._order.isApprovalRequired(o)
             ? 'View and approve order'
             : 'Order details';
    }
    /**
     * Output status specific to a card header
     */
    if (args === 'header') {
      if (this._order.isApprovalRequired(o)) {
        const today = new Date();
        const arbd = newDate(o.approvalRequiredByDate);
        // set date to end of day before subtraction
        arbd.setHours(23, 59, 59, 0);
        const diff = oStatus === 'MDP_ORDER_APPROVAL_REQUIRED'
                     ? Math.abs(today.getTime() - arbd.getTime())
                     : Math.abs(arbd.getTime() - today.getTime());
        const diffDays = Math.round(diff / (1000 * 3600 * 24));
        return oStatus === 'MDP_ORDER_APPROVAL_REQUIRED'
               ? `Approval due ${diffDays === 0
                                 ? ''
                                 : `in ${diffDays} day${diffDays > 1
                                                        ? 's'
                                                        : ''}`}`
               : `Approval past due`;
      }
      return statusTranslation[oStatus] || '';
    }
    /**
     * Output cards' sub header in order details
     */
    if (args === 'label') {
      return statusTranslationLabels[oStatus] || '';
    }
    /**
     * Output a date based on order status
     * Shipping by  -> estimatedShipDate
     * Arriving by -> estimatedDeliveryDate
     * Approval required by -> approvalRequiredByDate
     */
    if (args === 'date') {
      const statusScope = this._order.isApprovalRequired(o)
                          ? o.approvalRequiredByDate
                          : (oStatus === 'MDP_ORDER_SUBMITTED' || oStatus === 'MDP_ORDER_PRINTED' || oStatus === 'MDP_ORDER_APPROVED'
                             ? o.estimatedShipDate
                             : o.estimatedDeliveryDate);
      return `${this.date.transform(newDate(statusScope), 'MMMM d')}`;
    }
    /**
     *
     */
    if (oStatus === 'MDP_ORDER_APPROVAL_REQUIRED' || oStatus === 'MDP_ORDER_APPROVAL_PAST_DUE') {
      const txt = oStatus === 'MDP_ORDER_APPROVAL_REQUIRED'
                  ? `Please take a moment to approve your upcoming order, so we can get it to you on time.`
                  : `Please take a moment to approve your upcoming order. We will get it to you as soon as we can.`;
      return txt;
    } else if (oStatus === 'MDP_ORDER_AUTOFILL_REVIEW') {
      // deadline to oedit is next strip start date minus 10 days
      const nstd = newDate(o.nextStripStartDate);
      const deadline = new Date(nstd.setDate(nstd.getDate() - 10));
      const txt = `Your next SimpleDose&trade; pack will ship on ${this.monthDayOnly.transform(
        o.estimatedShipDate)}.
If you want to modify your order, you need to do so by ${this.monthDayOnly.transform(deadline)}.`;
      return txt;
      /**
       * Output status specific to MDP_ORDER_COMPLETED or MDP_ORDER_PICKEDUP(V2) with
       * order.estimatedDeliveryDate is expected Otherwise sub title translation is assumed to be
       * desired. business logic below
       */
    } else if (args && (oStatus === 'MDP_ORDER_COMPLETED' || oStatus === 'MDP_ORDER_PICKEDUP')) {
      // 2 days of estimatedDeliveryDate
      let withinTwoDays: boolean;
      const estDeliveryDate = newDate(args);
      const today = new Date();
      // today.setHours(0, 0, 0, 0);
      estDeliveryDate.setDate(estDeliveryDate.getDate() + 2);
      withinTwoDays = estDeliveryDate.getTime() > today.getTime();
      if (withinTwoDays) {
        const txt = reword
                    ? rewordDictionary['Arriving by']
                    : 'Arriving by';
        translated = `${txt} ${this.date.transform(newDate(args), 'MMMM d')}`;
      }
    } else {
      const txt = (reword
                   ? rewordDictionary[statusTranslationSubtitles[oStatus]]
                   : null) || statusTranslationSubtitles[oStatus] || '';
      return `${txt}${extraStr}`;
    }
    /**
     * Archived orders translation
     */
    if (this._order.isOrderHistory(o)) {
      const txt = reword
                  ? rewordDictionary['Arrived by']
                  : '<span>Arrived by</span>';
      translated = `${txt} ${this.monthDayOnly.transform(o.orderCompletedDate)}`;
    }
    return (translated || `<b>${statusTranslation[oStatus]}<b>` || '') + extraStr;
  }
}
